<template>
    <div class="min-h-screen bg-gray-50">
        <nav class="bg-white border-b border-gray-100 lg:fixed lg:w-full lg:z-50">
            <!-- Primary Navigation Menu -->
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between h-16">
                    <div class="flex">
                        <!-- Logo -->
                        <div class="flex-shrink-0 flex items-center">
                            <inertia-link :href="route('dashboard')">
                                <jet-application-mark class="m-auto" width="100" color="black"/>
                            </inertia-link>
                        </div>

                        <!-- Navigation Links -->
                        <div class="hidden space-x-3 sm:-my-px sm:ml-10 sm:flex">
                            <jet-nav-link :href="route('dashboard')"
                                          :active="$page.props.currentRouteName == 'dashboard'">
                                Início
                            </jet-nav-link>
                            <jet-nav-link :href="route('send.index')"
                                          :active="$page.props.currentRouteName == 'send.index'">
                                Enviar
                            </jet-nav-link>
                            <jet-nav-link :href="route('extract.index')"
                                          :active="$page.props.currentRouteName == 'extract.index'">
                                Extrato
                            </jet-nav-link>
                            <jet-nav-link v-if="false" :href="route('values-receive.index')"
                                          :active="$page.props.currentRouteName == 'valuesReceive.index'">
                                Receber
                            </jet-nav-link>
                            <jet-nav-link :href="route('transfer.index')"
                                          :active="$page.props.currentRouteName == 'transfer.index'">
                                Transferência
                            </jet-nav-link>
                            <jet-nav-link :href="route('pix.index')"
                                          :active="$page.props.currentRouteName == 'pix.index'">
                                Pix
                            </jet-nav-link>

                            <jet-nav-link :href="route('payment.index')"
                                          :active="$page.props.currentRouteName == 'payment.index'">
                                Pagamento
                            </jet-nav-link>

                            <jet-nav-link v-if="$page.props.profiles.includes('cripto')" :href="route('trade.index')"
                                          :active="$page.props.currentRouteName == 'trade.index'">
                                Cripto
                            </jet-nav-link>

                            <jet-nav-link :href="route('boleto.index')"
                                          :active="$page.props.currentRouteName == 'boleto.index'">
                                Boletos
                            </jet-nav-link>

                            <jet-nav-link v-if="$page.props.activeAccount.escrow_account && $page.props.escrowApprover"
                                          :href="route('pending-approvals.index')"
                                          :active="$page.props.currentRouteName == 'pending-approvals.index'">
                                          Autorizações
                            </jet-nav-link>

                            <!-- Acquiring -->
                            <div class="sm:flex sm:items-center sm:ml-6"
                                 v-if="$page.props.profiles.includes('adquirencia')">
                                <div class="ml-1 relative">
                                    <jet-dropdown align="center" width="20">
                                        <template #trigger>
                                            <button
                                                class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
                                                <div class="truncate text-right pr-2">
                                                    Adquirência
                                                </div>
                                                <div class="ml-1">
                                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd"
                                                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                              clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </button>
                                        </template>
                                        <template #content>
                                            <jet-dropdown-link :href="route('acquiring.dashboard')">
                                                Dashboard
                                            </jet-dropdown-link>

                                            <jet-dropdown-link :href="route('acquiring.transactions')">
                                                Transações
                                            </jet-dropdown-link>

                                            <jet-dropdown-link :href="route('acquiring.payments')">
                                                Pagamentos
                                            </jet-dropdown-link>

                                            <jet-dropdown-link :href="route('acquiring.devices')">
                                                Terminais
                                            </jet-dropdown-link>

                                            <jet-dropdown-link :href="route('acquiring.taxes')">
                                                Taxas
                                            </jet-dropdown-link>

                                        </template>
                                    </jet-dropdown>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Settings Dropdown -->
                    <div class="hidden sm:flex sm:items-center sm:ml-6">
                        <div class="ml-3 relative">
                            <jet-dropdown align="right" width="48">
                                <template #trigger>
                                    <button v-if="$page.props.jetstream.managesProfilePhotos"
                                            class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out">
                                        <img class="h-8 w-8 rounded-full object-cover"
                                             :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name"/>
                                    </button>

                                    <button v-else
                                            class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
                                        <div class="flex">
                                            <div v-tippy :content="$page.props.activeAccount.name"
                                                 class="truncate text-right w-32 pr-1">
                                                {{ $page.props.activeAccount.customer.name || $page.props.user.name }}
                                            </div>
                                            <div class="flex">&nbsp;|&nbsp;
                                                <span v-tippy
                                                      :content="'Banco ' + ($page.props.activeAccount.bank ? $page.props.activeAccount.bank.name : 'BMP Money Plus')">{{
                                                        $page.props.activeAccount.bank ? $page.props.activeAccount.bank.id : 274
                                                    }}</span>&nbsp;-&nbsp;
                                                <span v-tippy content="Agência">{{
                                                        $page.props.activeAccount.agency || '0001'
                                                    }}</span>&nbsp;-&nbsp;
                                                <span v-tippy content="Conta corrente">{{
                                                        $page.props.activeAccount.number
                                                    }}-{{ $page.props.activeAccount.digit }}</span></div>
                                        </div>

                                        <div class="ml-1">
                                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </div>
                                    </button>
                                </template>

                                <template #content>
                                    <!-- Account Management -->
                                    <div class="block px-4 py-2 text-xs text-gray-400">
                                        Minha conta
                                    </div>

                                    <jet-dropdown-link :href="route('profile.show')">
                                        Meu perfil
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('mobilebank.index')">
                                        Aplicativo móvel
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('select.index')">
                                        Selecionar outra conta
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('api-tokens.index')"
                                                       v-if="$page.props.jetstream.hasApiFeatures">
                                        API Tokens
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('reporterror.create')">
                                        Reportar erro
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('terms.index')">
                                        Termos de aceite
                                    </jet-dropdown-link>

                                    <div class="border-t border-gray-100"></div>

                                    <!-- Authentication -->
                                    <form @submit.prevent="logout">
                                        <jet-dropdown-link as="button">
                                            Sair
                                        </jet-dropdown-link>
                                    </form>
                                </template>
                            </jet-dropdown>
                        </div>
                    </div>

                    <!-- Hamburger -->
                    <div class="-mr-2 flex items-center sm:hidden">
                        <button @click="showingNavigationDropdown = ! showingNavigationDropdown"
                                class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
                            <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path
                                    :class="{'hidden': showingNavigationDropdown, 'inline-flex': ! showingNavigationDropdown }"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16"/>
                                <path
                                    :class="{'hidden': ! showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Responsive Navigation Menu -->
            <div :class="{'block': showingNavigationDropdown, 'hidden': ! showingNavigationDropdown}" class="sm:hidden">
                <div class="pt-2 pb-3 space-y-1">
                    <jet-responsive-nav-link :href="route('dashboard')"
                                             :active="$page.props.currentRouteName == 'dashboard'">
                        Dashboard
                    </jet-responsive-nav-link>
                </div>

                <!-- Responsive Settings Options -->
                <div class="pt-4 pb-1 border-t border-gray-200">
                    <div class="flex items-center px-4">
                        <div class="flex-shrink-0">
                            <img class="h-10 w-10 rounded-full" :src="$page.props.user.profile_photo_url"
                                 :alt="$page.props.user.name"/>
                        </div>

                        <div class="ml-3">
                            <div class="font-medium text-base text-gray-800">{{ $page.props.user.name }}</div>
                            <div class="font-medium text-sm text-gray-500">{{ $page.props.user.email }}</div>
                        </div>
                    </div>

                    <div class="mt-3 space-y-1">
                        <jet-responsive-nav-link :href="route('profile.show')"
                                                 :active="$page.props.currentRouteName == 'profile.show'">
                            Autenticação por 2 fatores
                        </jet-responsive-nav-link>

                        <jet-responsive-nav-link :href="route('select.index')"
                                                 :active="$page.props.currentRouteName == 'select.index'">
                            Selecionar outra conta
                        </jet-responsive-nav-link>

                        <!-- Authentication -->
                        <form method="POST" @submit.prevent="logout">
                            <jet-responsive-nav-link as="button">
                                Sair
                            </jet-responsive-nav-link>
                        </form>

                        <!-- Team Management -->
                        <template v-if="$page.props.jetstream.hasTeamFeatures">
                            <div class="border-t border-gray-200"></div>

                            <div class="block px-4 py-2 text-xs text-gray-400">
                                Manage Team
                            </div>

                            <!-- Team Settings -->
                            <jet-responsive-nav-link :href="route('teams.show', $page.props.user.current_team)"
                                                     :active="$page.props.currentRouteName == 'teams.show'">
                                Team Settings
                            </jet-responsive-nav-link>

                            <jet-responsive-nav-link :href="route('teams.create')"
                                                     :active="$page.props.currentRouteName == 'teams.create'">
                                Create New Team
                            </jet-responsive-nav-link>

                            <div class="border-t border-gray-200"></div>

                            <!-- Team Switcher -->
                            <div class="block px-4 py-2 text-xs text-gray-400">
                                Switch Teams
                            </div>

                            <template v-for="team in $page.props.user.all_teams">
                                <form @submit.prevent="switchToTeam(team)" :key="team.id">
                                    <jet-responsive-nav-link as="button">
                                        <div class="flex items-center">
                                            <svg v-if="team.id == $page.props.user.current_team_id"
                                                 class="mr-2 h-5 w-5 text-green-400" fill="none" stroke-linecap="round"
                                                 stroke-linejoin="round" stroke-width="2" stroke="currentColor"
                                                 viewBox="0 0 24 24">
                                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                            </svg>
                                            <div>{{ team.name }}</div>
                                        </div>
                                    </jet-responsive-nav-link>
                                </form>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </nav>

        <!-- Page Heading -->
        <header class="bg-white shadow lg:fixed lg:w-full lg:mt-16 lg:z-40">
            <div class="max-w-7xl mx-auto py-6 lg:py-4 px-4 sm:px-6 lg:px-8">
                <slot name="header"></slot>
            </div>
        </header>

        <!-- Page Content -->
        <main class="lg:pt-32">
            <slot></slot>
        </main>

        <!-- Modal Portal -->
        <portal-target name="modal" multiple>
        </portal-target>
    </div>
</template>

<script>
import JetApplicationLogo from './../Jetstream/ApplicationLogo'
import JetApplicationMark from './../Jetstream/ApplicationMark'
import JetDropdown from './../Jetstream/Dropdown'
import JetDropdownLink from './../Jetstream/DropdownLink'
import JetNavLink from './../Jetstream/NavLink'
import JetResponsiveNavLink from './../Jetstream/ResponsiveNavLink'

export default {
    components: {
        JetApplicationLogo,
        JetApplicationMark,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {
                'team_id': team.id
            }, {
                preserveState: false
            })
        },
        logout() {
            axios.post(route('logout').url()).then(response => {
                window.location = '/';
            })
        },
    },

    computed: {
        path() {
            return window.location.pathname
        }
    }
}
</script>
